import Button from '@components/Button';
import { showConfirmModal } from '@components/ConfirmModal';
import Icon from '@components/Icon';
import { $curSandTable } from '@stores/dataStores';
import {
  $editingImageMarker,
  $editingImageMarkerApi,
} from '@stores/editingMarkerStores';
import { $stImageSettingPanelApi } from '@stores/sandTableStores';
import { SandTableType } from '@types';
import { delay } from 'pano-utils';
import { backToListMode } from '../actions/backToListMode';
import ImgSetting from './img-setting.png';

function ImageEditorButtons() {
  const handleSetting = async () => {
    const editing = $editingImageMarker.getState();
    const editingId = editing?.marker.id;
    const sandTable = $curSandTable.getState();
    if (
      editingId &&
      (sandTable?.type === SandTableType.image ||
        sandTable?.type === SandTableType.matrix)
    ) {
      const oldData = sandTable.markers.find((x) => x.id === editingId)!;
      if (editing?.marker !== oldData || editing?.isNew) {
        const { confirmed } = await showConfirmModal({
          title: '有未保存的更改',
          content: '当前所有未经保存的改动将丢失, 是否继续?',
        });
        if (!confirmed) return;
      }
      $editingImageMarkerApi.clear();
      await delay(100);
    }
    $stImageSettingPanelApi.toggle();
    backToListMode();
  };

  return (
    <div className="absolute top-20 right-20 flex items-center">
      <Button className="ml-15" onClick={handleSetting}>
        <Icon src={ImgSetting} className="mr-5" />
        沙盘高级设置
      </Button>
    </div>
  );
}

export default ImageEditorButtons;
